module.exports = __webpack_public_path__ + "img/velosofi-icon.3adb15ac.png";